export default "__VITE_ASSET__CFZqzBcX__"